import { Injectable } from '@angular/core';
import { UserAccessibleCompanyServer } from '../core-data-model/CompaniesApi.serverinterface';
import { Company } from '../core-data-model/Company.model';

@Injectable({ providedIn: 'root' })
export class CompaniesApiTransformer {
    transformUserAccessibleCompanyServerToClient(
        userAccessibleCompany: UserAccessibleCompanyServer
    ) {
        return new Company({
            id: userAccessibleCompany.companyId,
            shortPublicId: userAccessibleCompany.shortPublicCompanyId,
            name: userAccessibleCompany.name,
            isDefault: userAccessibleCompany.isDefaultCompany,
            companyClassificationType:
                userAccessibleCompany.companyClassificationType
        });
    }
}
